<datex-grid #$gridComponent *ngIf="initialized && !$hasMissingRequiredInParams"  [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"
[canEdit]="canEdit"
[canAdd]="canAdd" [addNewRowFn]="addRow.bind(this)" [addLineModel]="bottomToolbar.addLine"

>
    <ng-container topToolbar>
  </ng-container>


  <ng-container gridColumnDef="line_number">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.line_number.displayControl.styles.style"
          [ngClass]="row.cells.line_number.displayControl.styles.classes"
          [matTooltip]="row.cells.line_number.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.line_number.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="component">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.component.displayControl.styles.style"
          [ngClass]="row.cells.component.displayControl.styles.classes"
          [matTooltip]="row.cells.component.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.component.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="source_license_plate">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.source_license_plate.displayControl.styles.style"
          [ngClass]="row.cells.source_license_plate.displayControl.styles.classes"
          [matTooltip]="row.cells.source_license_plate.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.source_license_plate.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="lot">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.lot.displayControl.styles.style"
          [ngClass]="row.cells.lot.displayControl.styles.classes"
          [matTooltip]="row.cells.lot.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.lot.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="remaining_quantity">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.remaining_quantity.displayControl.styles.style"
          [ngClass]="row.cells.remaining_quantity.displayControl.styles.classes"
          [matTooltip]="row.cells.remaining_quantity.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.remaining_quantity.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="new_inventory_quantity">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.new_inventory_quantity.displayControl.styles.style"
          [ngClass]="row.cells.new_inventory_quantity.displayControl.styles.classes"
          [matTooltip]="row.cells.new_inventory_quantity.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.new_inventory_quantity.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="numberBox" [formControl]="row.formGroup.controls['new_inventory_quantity_edit']"
            matInput
            numberBox
            [format]="row.cells.new_inventory_quantity.editControl.format"
            autocomplete="off"
            spellcheck="false"
            class="datex-numberbox {{ (row.cells.new_inventory_quantity.editControl.readOnly || row.cells.new_inventory_quantity.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.new_inventory_quantity.editControl.placeholder}}"
            [ngStyle]="row.cells.new_inventory_quantity.editControl.styles.style"
            [ngClass]="row.cells.new_inventory_quantity.editControl.styles.classes"
            [matTooltip]="row.cells.new_inventory_quantity.editControl.tooltip"
            matTooltipClass="datex-control-tooltip">
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="license_plate">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.license_plate.displayControl.styles.style"
          [ngClass]="row.cells.license_plate.displayControl.styles.classes"
          [matTooltip]="row.cells.license_plate.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.license_plate.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <Manufacturing-licenseplates_by_location_single 
        data-cy="selector"
        [type]="row.cells.license_plate.editControl.type"
        [formControl]="row.formGroup.controls['license_plate_edit']"
        (displayTextChange)="row.cells.license_plate.editControl.displayText=$event"
        [placeholder]="row.cells.license_plate.editControl.placeholder"
        [styles]="row.cells.license_plate.editControl.styles"
        [tooltip]="row.cells.license_plate.editControl.tooltip"
      [location_id]="row.$fields_license_plate_selector_inParams_location_id"
    >
    </Manufacturing-licenseplates_by_location_single>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="target_lot">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.target_lot.displayControl.styles.style"
          [ngClass]="row.cells.target_lot.displayControl.styles.classes"
          [matTooltip]="row.cells.target_lot.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.target_lot.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <Manufacturing-lots_by_material_ids_single 
        data-cy="selector"
        [type]="row.cells.target_lot.editControl.type"
        [formControl]="row.formGroup.controls['target_lot_edit']"
        (displayTextChange)="row.cells.target_lot.editControl.displayText=$event"
        [placeholder]="row.cells.target_lot.editControl.placeholder"
        [styles]="row.cells.target_lot.editControl.styles"
        [tooltip]="row.cells.target_lot.editControl.tooltip"
      [material_ids]="row.$fields_target_lot_selector_inParams_material_ids"
    >
    </Manufacturing-lots_by_material_ids_single>
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
<div *ngIf="$hasMissingRequiredInParams" class="missing-params">
  <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
</div>
